import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ownerName: string;
  onConfirm: (month: string) => void;
  loading?: boolean;
}

const currentYearMonth = () => new Date().toISOString().slice(0, 7);

export const CollectMonthDialog = ({
  open,
  onOpenChange,
  ownerName,
  onConfirm,
  loading = false,
}: Props) => {
  const [month, setMonth] = useState(currentYearMonth);

  const handleConfirm = () => {
    onConfirm(month);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Mark Month as Collected</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <p className="text-sm text-muted-foreground">
            Recording manual collection for{" "}
            <span className="font-medium text-foreground">{ownerName}</span>.
          </p>
          <div className="space-y-1.5">
            <label className="text-sm font-medium" htmlFor="collect-month">
              Month
            </label>
            <input
              id="collect-month"
              type="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={loading || !month}>
            {loading ? "Saving…" : "Confirm Collected"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
